import React from 'react';
import Icon from 'components/AppIcon';

const TeamSlide = () => {
  const leadership = [
    {
      name: 'Ricky Omondi',
      role: 'Founder',
      background: 'Visionary leader driving LawDesk KE\'s mission to transform legal access in Kenya',
      experience: 'Legal Technology & Entrepreneurship',
      expertise: ['Legal Technology', 'Business Strategy', 'Market Development'],
      icon: 'User'
    },
    {
      name: 'Bryant Smith',
      role: 'Co-Founder',
      background: 'Co-driving the platform\'s technical and operational excellence',
      experience: 'Technology & Operations Leadership',
      expertise: ['Platform Development', 'Operations', 'Growth Strategy'],
      icon: 'Code'
    },
    {
      name: '',
      role: 'VP of Business Development',
      background: 'Leading business development and market expansion initiatives',
      experience: '10+ years business development',
      expertise: ['Sales Strategy', 'Client Relations', 'Market Expansion'],
      icon: 'TrendingUp'
    }
  ];

  const advisoryBoard = [
    {
      name: '',
      role: 'Legal Advisory',
      background: 'Former High Court Judge',
      contribution: 'Legal system insights and regulatory guidance'
    },
    {
      name: '',
      role: 'Technology Advisory',
      background: 'Professor of Computer Science, University of Nairobi',
      contribution: 'Technical architecture and innovation strategy'
    },
    {
      name: '',
      role: 'Business Advisory',
      background: 'Former CEO of Major Kenyan Corporation',
      contribution: 'Strategic planning and market entry strategy'
    },
    {
      name: '',
      role: 'Legal Practice Advisory',
      background: 'President, Law Society of Kenya',
      contribution: 'Industry standards and professional compliance'
    }
  ];

  const teamStats = [
    {
      icon: 'Users',
      title: 'Core Team',
      value: '12',
      description: 'Full-time dedicated professionals'
    },
    {
      icon: 'GraduationCap',
      title: 'Combined Experience',
      value: '150+',
      description: 'Years of industry experience'
    },
    {
      icon: 'Award',
      title: 'Industry Recognition',
      value: '5',
      description: 'Team members with industry awards'
    },
    {
      icon: 'Globe',
      title: 'Market Coverage',
      value: '100%',
      description: 'Kenya market understanding'
    }
  ];

  const keyDepartments = [
    {
      department: 'Legal & Compliance',
      size: 3,
      focus: 'Regulatory compliance, legal expertise, industry relations',
      icon: 'Scale'
    },
    {
      department: 'Technology',
      size: 5,
      focus: 'Platform development, security, infrastructure',
      icon: 'Code'
    },
    {
      department: 'Business Development',
      size: 2,
      focus: 'Sales, marketing, customer success',
      icon: 'TrendingUp'
    },
    {
      department: 'Operations',
      size: 2,
      focus: 'Finance, HR, administration',
      icon: 'Settings'
    }
  ];

  return (
    <div className="py-12">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-heading font-bold text-text-primary mb-4">
            Our Team
          </h1>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            Experienced professionals combining legal expertise with technology innovation
          </p>
        </div>

        {/* Leadership Team */}
        <div className="mb-12">
          <h2 className="text-2xl font-heading font-bold text-text-primary mb-8 text-center">
            Leadership Team
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {leadership?.map((leader, index) => (
              <div key={index} className="bg-surface rounded-lg p-6 shadow-card border border-border text-center">
                <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name={leader?.icon} size={32} color="white" />
                </div>
                {leader?.name ? (
                  <h3 className="text-xl font-heading font-bold text-text-primary mb-1">
                    {leader?.name}
                  </h3>
                ) : (
                  <div className="h-7 mb-1"></div>
                )}
                <div className="text-primary font-medium mb-2">
                  {leader?.role}
                </div>
                <p className="text-text-secondary text-sm mb-3">
                  {leader?.background}
                </p>
                <div className="text-xs text-text-secondary mb-4">
                  {leader?.experience}
                </div>
                <div className="flex flex-wrap gap-2 justify-center">
                  {leader?.expertise?.map((skill, skillIndex) => (
                    <span key={skillIndex} className="px-2 py-1 bg-primary-50 text-primary rounded text-xs">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Team Statistics */}
        <div className="mb-12">
          <h2 className="text-2xl font-heading font-bold text-text-primary mb-8 text-center">
            Team Strength
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {teamStats?.map((stat, index) => (
              <div key={index} className="bg-gradient-to-br from-primary-50 to-secondary-50 rounded-lg p-6 text-center">
                <div className="w-16 h-16 bg-primary rounded-xl flex items-center justify-center mx-auto mb-4">
                  <Icon name={stat?.icon} size={32} color="white" />
                </div>
                <div className="text-3xl font-heading font-bold text-primary mb-2">
                  {stat?.value}
                </div>
                <h3 className="font-heading font-semibold text-text-primary mb-1">
                  {stat?.title}
                </h3>
                <p className="text-sm text-text-secondary">
                  {stat?.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Department Structure */}
        <div className="mb-12">
          <h2 className="text-2xl font-heading font-bold text-text-primary mb-8 text-center">
            Team Structure
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {keyDepartments?.map((dept, index) => (
              <div key={index} className="bg-surface rounded-lg p-6 shadow-card border border-border">
                <div className="flex items-center space-x-4 mb-4">
                  <div className="w-12 h-12 bg-secondary-100 rounded-lg flex items-center justify-center">
                    <Icon name={dept?.icon} size={24} className="text-secondary-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-heading font-semibold text-text-primary">
                      {dept?.department}
                    </h3>
                    <div className="text-sm text-text-secondary">
                      {dept?.size} team members
                    </div>
                  </div>
                </div>
                <p className="text-text-secondary text-sm">
                  {dept?.focus}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Advisory Board */}
        <div className="bg-surface rounded-lg p-8 shadow-card border border-border">
          <h2 className="text-2xl font-heading font-bold text-text-primary mb-8 text-center">
            Advisory Board
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {advisoryBoard?.map((advisor, index) => (
              <div key={index} className="flex items-start space-x-4 p-4 bg-secondary-50 rounded-lg">
                <div className="w-12 h-12 bg-secondary-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <Icon name="User" size={20} color="white" />
                </div>
                <div className="flex-1">
                  {advisor?.name ? (
                    <h3 className="font-heading font-semibold text-text-primary mb-1">
                      {advisor?.name}
                    </h3>
                  ) : (
                    <div className="h-5 mb-1"></div>
                  )}
                  <div className="text-sm text-secondary-600 font-medium mb-1">
                    {advisor?.role}
                  </div>
                  <div className="text-sm text-text-secondary mb-2">
                    {advisor?.background}
                  </div>
                  <p className="text-xs text-text-secondary">
                    {advisor?.contribution}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Why Our Team */}
        <div className="mt-12 bg-gradient-to-r from-primary-50 to-secondary-50 rounded-lg p-8">
          <h2 className="text-2xl font-heading font-bold text-text-primary mb-6 text-center">
            Why Our Team Will Succeed
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-primary rounded-xl flex items-center justify-center mx-auto mb-4">
                <Icon name="Scale" size={32} color="white" />
              </div>
              <h3 className="font-heading font-semibold text-text-primary mb-2">
                Legal Expertise
              </h3>
              <p className="text-text-secondary text-sm">
                Deep understanding of Kenyan legal system and practice requirements
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-secondary-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <Icon name="Code" size={32} color="white" />
              </div>
              <h3 className="font-heading font-semibold text-text-primary mb-2">
                Technical Excellence
              </h3>
              <p className="text-text-secondary text-sm">
                Proven track record in building scalable, secure platforms
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-success-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <Icon name="Users" size={32} color="white" />
              </div>
              <h3 className="font-heading font-semibold text-text-primary mb-2">
                Market Knowledge
              </h3>
              <p className="text-text-secondary text-sm">
                Established relationships and deep understanding of target market
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamSlide;